(function ($) {
  let slideBarToggle = null;

  function toggleDropdown(event) {
    event.preventDefault();
    event.stopPropagation();

    const $navWrapper = $('.nav-mobile-wrapper');
    const $mobileMenu = $('#mobile-menu');
    const $toggle = $(this);
    const $li = $toggle.closest('.dropdown');

    // Fermer tous les autres sous-menus ouverts
    $('.dropdown').not($li).removeClass('opened');

    if ($li.hasClass('opened')) {
      $li.removeClass('opened');
    } else {
      $li.addClass('opened');
    }

    if (
      $navWrapper.hasClass('submenu-opened') ||
      $mobileMenu.hasClass('submenu-opened')
    ) {
      $navWrapper.removeClass('submenu-opened');
      $mobileMenu.removeClass('submenu-opened');
    } else {
      $navWrapper.addClass('submenu-opened');
      $mobileMenu.addClass('submenu-opened');
    }
  }

  function prepareDropdownForNav($nav) {
    $nav.removeClass('opened');
    ///// INIT SLIDER POSITION /////
    $nav.find('.active').addClass('opened');

    ///// INIT EVENTS /////
    $nav.find('.dropdown__toggle').on('click', toggleDropdown);
  }

  function closeSlidebarMenu() {
    slideBarToggle.attr('aria-expanded', false);
    $('body').removeClass('mobile-menu-open');
    $(document).off('click.close_slidebar').off('keyup.close_slidebar');
  }

  function tryClosingSlidebarMenu(event) {
    // Keyboard
    if ('undefined' !== typeof event.keyCode) {
      // ESCAPE
      if (27 === event.keyCode) {
        $('.vtx-burger-container').focus();
        closeSlidebarMenu();
      }
    }
    // Click
    else if (!$(event.target).closest('#mobile-menu-wrapper').length) {
      closeSlidebarMenu();
    }
  }

  function openSlidebarMenu() {
    slideBarToggle.attr('aria-expanded', true);
    $('body').addClass('mobile-menu-open');
    $(document)
      .on('click.close_slidebar', tryClosingSlidebarMenu)
      .on('keyup.close_slidebar', tryClosingSlidebarMenu);
  }

  function initMenuMobile() {
    slideBarToggle = $('.vtx-burger-container');

    const $mobileMenu = $('#mobile-menu');

    slideBarToggle.on('click', function (event) {
      event.stopPropagation();

      if ($('body').hasClass('mobile-menu-open')) {
        closeSlidebarMenu();
      } else {
        openSlidebarMenu();
      }
    });
    prepareDropdownForNav($mobileMenu.find('.nav-mobile'));
  }

  function addSubMenuBackBtn() {
    const dropdownSubnavWrapper = $('.nav-mobile-wrapper > ul');

    dropdownSubnavWrapper.find('.dropdown').each(function () {
      const subNavTitle = $(this).find('.nav-item__link:first').text();
      $(this)
        .children('.dropdown__subnav-wrapper')
        .prepend(
          '<li class="nav-item nav-item-title"><div class="nav-item__link-wrapper">' +
            subNavTitle +
            '</div></li>'
        );
    });

    $('.nav-back__link').on('click', toggleDropdown);
  }

  $(document).ready(function () {
    initMenuMobile();

    addSubMenuBackBtn();

    if ($('body').hasClass('page-parent')) {
      $('.nav-mobile-wrapper').addClass('submenu-opened');
      $('#mobile-menu').addClass('submenu-opened');
    }

    $('.close-menu-btn').on('click', function () {
      if ($('body').hasClass('mobile-menu-open')) {
        closeSlidebarMenu();
      } else {
        openSlidebarMenu();
      }
    });
  });
})(jQuery);
